export enum CompanyStatusEnum {
  ACTIVE = 'active',
  INACTIVE = 'inactive'
}
